import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 219.19 219.18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M109.59 219.18c60.53 0 109.6-49.07 109.6-109.59S170.12 0 109.59 0 0 49.06 0 109.59s49.07 109.59 109.59 109.59",
      style: {"fill":"#ed1c24"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.65 98.26h97.37s12.17-.81 17.04 4.87c4.87 5.68 13.2 12.99 13.2 12.99s3.84 6.49 14.39 0C171.74 108.68 184 100.7 184 100.7l-7.31-6.49h34.89l-51.12 36.52s-9.74 8.92-19.12 0c-11.23-10.68-16.18-6.08-24.69 0-6.61 4.72-26.78 19.47-26.78 19.47H31.45l55.99-41.38-81.96.35",
      style: {"fill":"#fff"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "BG-logo"}) } }